import Vue from 'vue';
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage';
import RegisterPage from '../views/RegisterPage';
import ResetPasswordPage from '../views/ResetPasswordPage';
import TutorialPage from '../views/TutorialPage';
import SelectAreaPage from '../views/SelectAreaPage';
import SelectSituationPage from '../views/SelectSituationPage';
import SituationVideoPage from '../views/SituationVideoPage';
import PlayPage from '../views/PlayPage';
import ClueResumePage from '../views/ClueResumePage';
import InterventionPage from '../views/InterventionPage';
// import RetroactionPage from '../views/RetroactionPage';
// import CorrectionPage from '../views/CorrectionPage'; // TBD - this is only in old version
import ConclusionPage from '../views/ConclusionPage';
import QuizRecapPage from '../views/QuizRecapPage';
import Blocnote from '../views/Blocnote';
import Sitemap from '../views/Sitemap';
import AnimationSheetHomePage from '../views/AnimationSheetHomePage';
import PourAllerPlusLoinPage from '../views/PourAllerPlusLoinPage';
import PourAllerPlusLoinHomePage from '../views/PourAllerPlusLoinHomePage';
import AnimationSheetPage from '../views/AnimationSheetPage';
import FaqPage from '../views/FaqPage';
import AstucesPage from '../views/AstucesPage';

Vue.use(VueRouter);

// These are all the routes (pages) we can navigate to in the App, using VueRouter
// We inject our router in the app so we can call something like this to navigate home:  this.$router.push("/");

// Proposed translations
//  register = inscription
//  reset    = reinitialiser
//  tutorial  = tutoriel
//  area      = environment
//  situations = situations
//  video      = video
//  play       = jouer
//  resume     = resume
//  intervention  = intervention
//  conclusion    = conclusion
//  quizrecap     = sommaire
const routes = [
    { path: '/', name: 'home', component: HomePage },

    { path: '/inscription', name: 'register', component: RegisterPage },
    { path: '/reinitialiser', name: 'reset', component: ResetPasswordPage },

    { path: '/environment', name: 'area', component: SelectAreaPage },

    { path: '/:areaName/situations', name: 'situations', component: SelectSituationPage },

    { path: '/:areaName/:situationName/video', name: 'video', component: SituationVideoPage },
    { path: '/:areaName/:situationName/tutoriel', name: 'tutorial', component: TutorialPage },


    { path: '/:areaName/:situationName/jouer', name: 'play', component: PlayPage },
    { path: '/:areaName/:situationName/resume', name: 'resume', component: ClueResumePage },


    { path: '/:areaName/:situationName/intervention', name: 'intervention', component: InterventionPage },
    { path: '/:areaName/:situationName/conclusion', name: 'conclusion', component: ConclusionPage },
    // Storyline
    { path: '/:areaName/:situationName/sommaire', name: 'quizrecap', component: QuizRecapPage },


    { path: '/bloc-notes', name: 'Blocnote', component: Blocnote },
    { path: '/plan-de-site', name: 'Sitemap', component: Sitemap },

    { path: '/faq', name: 'FAQ', component: FaqPage },
    { path: '/astuces', name: 'Astuces', component: AstucesPage },


    { path: '/fiches-d-animation-de-communautes-d-apprentissage', name: 'AnimationSheetHomePage', component: AnimationSheetHomePage },
    {
        path: '/fiches-d-animation-de-communautes-d-apprentissage/creer-des-liens-pour-le-bien-etre-et-l-apprentissage-de-l-enfant',
        name: 'AnimationSheet1', component: AnimationSheetPage, props: { ficheId: 0 }
    },
    {
        path: '/fiches-d-animation-de-communautes-d-apprentissage/partons-explorer-avec-les-enfants',
        name: 'AnimationSheet2', component: AnimationSheetPage, props: { ficheId: 1 }
    },
    {
        path: '/fiches-d-animation-de-communautes-d-apprentissage/l-environnement-pour-nous-appuyer',
        name: 'AnimationSheet3', component: AnimationSheetPage, props: { ficheId: 2 }
    },
    {
        path: '/fiches-d-animation-de-communautes-d-apprentissage/familles-engagees-enfants-epanouies-et-epanouis',
        name: 'AnimationSheet4', component: AnimationSheetPage, props: { ficheId: 3 }
    },



    { path: '/ressources-pour-aller-plus-loin', name: 'pourAllerPlusLoinHomePage', component: PourAllerPlusLoinHomePage, },
    {
        path: '/ressources-pour-aller-plus-loin/les-relations-authentiques',
        name: 'pourAllerPlusLoin1', component: PourAllerPlusLoinPage, props: { allerPlusLoinId: 0 }
    },
    {
        path: '/ressources-pour-aller-plus-loin/l-apprentissage-par-l-exploration-le-jeu-et-l-enquete.',
        name: 'pourAllerPlusLoin2', component: PourAllerPlusLoinPage, props: { allerPlusLoinId: 1 }
    },
    {
        path: '/ressources-pour-aller-plus-loin/l-environnement-comme-troisieme-educateur',
        name: 'pourAllerPlusLoin3', component: PourAllerPlusLoinPage, props: { allerPlusLoinId: 2 }
    },
    {
        path: '/ressources-pour-aller-plus-loin/l-engagement-familial',
        name: 'pourAllerPlusLoin4', component: PourAllerPlusLoinPage, props: { allerPlusLoinId: 3 }
    },


    // { path: '/retroaction', name: 'retroaction', component: RetroactionPage }, // old version
    // { path: '/correction', name: 'correction', component: CorrectionPage }, // TBD this is only in old version

]
export const router = new VueRouter({
    mode: 'history',
    routes,
})